<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics

========================================================================================== -->

<template>

  <div id="dashboard-home">
    <div class="vx-row">
      <div class="vx-col w-full mb-6">
        <div class="knowledge-base-jumbotron-content rounded-lg p-8 lg:p-12 vx-card"
             style="background-image: url(https://cdn.discordapp.com/attachments/746242308084858900/878036059005526016/sylvain-mauroux-jYCUBAIUsk8-unsplash.jpg); background-position: center">
          <div class="flex justify-between items-center">
            <div class="flex flex-wrap content-center pl-6 pr-6">
              <h1 class="mb-2 text-white w-full" style="font-size: 4rem">Lets Get Started {{
                  activeUserInfo.first_name
                }}!</h1>
              <p class="text-white w-full" style="font-size: 1.5rem" v-if="activeCourseInfo.selected">You are currently
                practicing {{ activeCourseInfo.name }}</p>
              <p class="text-white w-full" style="font-size: 1.5rem" v-if="!activeCourseInfo.selected">No Course
                Selected, Begin By Selecting Your Active Course</p>
              <!--- <vs-progress
                :percent="dashboard_course_percent" style="max-width: 600px"
                class="block mt-6 shadow-md self-center w-2/3" color="success"></vs-progress> --->
            </div>
            <img class="rounded ml-10" :src="activeCourseInfo.thumbnail" v-if="activeCourseInfo.thumbnail" width="150px"
                 height="150px">
          </div>
        </div>
      </div>
    </div>

    <div v-if="!activeCourseInfo.selected" class="vx-row match-height mb-base">
      <div class="vx-col w-full">
        <vx-card class="carousel-example" title="Course Selector">
          <div v-if="courses_loaded">
            <swiper :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="swiperOption">
              <swiper-slide v-for="item in courses_total" :key="item.id">
                <course-dashboard-card :item="item"/>
              </swiper-slide>
              <div slot="pagination" class="swiper-pagination"></div>
            </swiper>
          </div>
          <dashboard-card-skeleton v-else class="mt-2"></dashboard-card-skeleton>
          <h1 v-if="courses_none">You Have No Courses On Your Account</h1>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import DashboardCardSkeleton from '@/components/skeleton-loading/DashboardCardSkeleton'
import CourseDashboardCard from '@/views/course/course-selector/components/CourseDashboardCard'
import 'swiper/dist/css/swiper.min.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  data () {
    return {

      items: [],
      items_local: [],

      courses_total: [],
      courses_loaded: false,
      courses_none: false,

      has_simulations: false,
      show_hidden_simulations: false,

      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    CourseDashboardCard,
    DashboardCardSkeleton,
    swiper,
    swiperSlide,

  },
  methods: {
    get_course_list () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {

          const newCourses = []

          if (subscriptions.data.data.length === 0) {
            this.courses_none = true
            this.courses_loaded = true
            // location.replace('https://www.youtube.com/watch?v=jE2VvGZktJo')
          }

          subscriptions.data.data.forEach(x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {
                  newCourses.push(response.data.data)
                  this.courses_total = newCourses
                  this.courses_loaded = true
                }
              })
          })

        })
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'legacy-simulation-starter', params: {simulationId: this.item.id}})
        .catch(() => {
        })
    },
    load_current_selector () {
      if (this.activeCourseInfo.selected) {
        // this.load_simulations_data()
      }

      if (!this.activeCourseInfo.selected) {
        this.get_course_list()
      }
    },
    resizedWindow () {
      const width = window.innerWidth
      if (width > 2200) {
        this.swiperOption.slidesPerView = 5
      }
      if (width < 1900) {
        this.swiperOption.slidesPerView = 4
      }
      if (width < 1500) {
        this.swiperOption.slidesPerView = 3
      }
      if (width < 950) {
        this.swiperOption.slidesPerView = 2
      }
      if (width < 500) {
        this.swiperOption.slidesPerView = 1
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizedWindow)
  },
  beforeMount () {
    this.load_current_selector()
    this.resizedWindow()
    window.addEventListener('resize', this.resizedWindow)

    if (this.activeCourseInfo.selected === '') {
      this.$store.dispatch('auth/refreshCourseObject').then(() => {
        this.load_current_selector()
      })
    }

  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  watch: {
    // activeCourseInfo (newValue) {
    //   alert(`yes, computed property changed: ${newValue}`)
    // }
  }
}
</script>

<style lang="scss">
